import React from 'react';
import Projects from '../../../Components/Projects/Projects';

const AllProjects = () => {
    return (
        <section className='mt-12'>
            {/* <div className='md:mx-0 mx-5'>
                <h1 className='text-5xl font-bold text-center' style={{ color: '#65647C' }}>All Projects</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-3 mb-10"></hr>
            </div> */}
            <Projects></Projects>
        </section>
    );
};

export default AllProjects;